import styled from 'styled-components'
import { GatsbyImage } from 'gatsby-plugin-image'
import { breakpoints, HiddenOnDesktop } from 'src/utils/styles/global-styles'
import { Header as CounterHeader } from '../Counter/styles'

export const Container = styled.div`
  display: grid;
  grid-template-columns: 45% 55%;
  gap: 2rem;
  padding: 0px 2rem 0px;
  @media (max-width: ${breakpoints.l}px) {
    grid-template-columns: 1fr;
    align-items: center;
    gap: 0px;
    padding: 0px;
  }
`
export const Header = styled.h1`
  font-size: 56px;
  line-height: 1;
  margin: 0px;
  text-align: left;
  @media (max-width: ${breakpoints.xl}px) {
    font-size: 36px;
    line-height: 40px;
  }
  @media (max-width: ${breakpoints.l}px) {
    text-align: center;
  }
  @media (max-width: ${breakpoints.s}px) {
    font-size: 28px;
    line-height: 32px;
  }
`
export const Subheading = styled.h1`
  font-family: 'MatterRegular';
  font-size: 26px;
  line-height: 150%;
  margin: 10px 0px 10px;
  text-align: left;
  @media (max-width: ${breakpoints.xl}px) {
    font-size: 24px;
    line-height: 26px;
  }
  @media (max-width: ${breakpoints.l}px) {
    text-align: center;
  }
  @media (max-width: ${breakpoints.s}px) {
    font-size: 16px;
    line-height: 24px;
    margin: 0px;
  }
`

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`
export const ImageContainer = styled.div`
  position: relative;
  z-index: 2;
  @media (max-width: ${breakpoints.l}px) {
    margin-left: 5%;
  }
`
export const BadgeContainer = styled.div`
  position: absolute;
  width: 120px;
  height: 120px;
  top: ${(props) => (props.isFrame2Page ? '60px' : '12px')};
  right: ${(props) => (props.isFrame2Page ? '15%' : '20px')};
  z-index: 3;
  @media (max-width: 1400px) {
    top: ${(props) => (props.isFrame2Page ? '20px' : '12px')};
  }
  @media (max-width: ${breakpoints.m}px) {
    width: 82px;
    height: 82px;
    top: ${(props) => (props.isFrame2Page ? '20px' : '8px')};
    right: ${(props) => (props.isFrame2Page ? '100px' : '10px')};
  }
  @media (max-width: ${breakpoints.s}px) {
    right: ${(props) => (props.isFrame2Page ? '20px' : '10px')};
  }
`
export const BadgeImage = styled(GatsbyImage)`
  z-index: 4;
`
export const CtaContainer = styled.div`
  display: flex;
  padding-bottom: 48px;
  gap: ${(props) => (props.gap ? '16px' : '0px')};
  white-space: nowrap;
  a {
    padding: 15px 48px;
  }
  @media (max-width: ${breakpoints.xl}px) {
    a {
      padding: 15px 32px;
    }
  }
  @media (max-width: ${breakpoints.l}px) {
    justify-content: center;
    padding-bottom: 0px;
  }
  @media (max-width: ${breakpoints.s}px) {
    flex-direction: ${(props) => (props.gap ? 'column' : 'row')};
    a {
      padding: 15px 20px;
      text-align: center;
      width: 100%;
    }
  }
`

export const LogoImageContainer = styled.div`
  width: 90px;
  @media (max-width: ${breakpoints.l}px) {
    width: 70px;
  }
  @media (max-width: 365px) {
    margin: 0px -4px;
  }
`
export const SubHeading = styled(Subheading)`
  line-height: 150%;
  max-width: 550px;
  margin-bottom: 40px;
  @media (max-width: ${breakpoints.xl}px) {
    max-width: 100%;
    line-height: 1.2;
    font-size: 20px;
    margin-bottom: 32px;
  }
  @media (max-width: ${breakpoints.s}px) {
    margin: 8px 0px 0px;
    font-size: 18px;
  }
`
export const Heading = styled(Header)`
  max-width: ${(props) => (props.small ? '420px' : '600px')};
  margin-top: 8px;
  @media (max-width: ${breakpoints.xl}px) {
    max-width: ${(props) => (props.small ? '320px' : '370px')};
  }
  @media (max-width: ${breakpoints.l}px) {
    margin: auto;
  }
  @media (max-width: ${breakpoints.s}px) {
    max-width: ${(props) => (props.small ? '240px' : '320px')};
    font-size: 28px;
    line-height: 32px;
    letter-spacing: 0.17px;
    width: ${(props) => (props.bfcmCal ? '220px' : '100%')};
  }
`
export const SyncsHeader = styled(CounterHeader)`
  margin: 8px 0px;
  font-size: 24px;
  color: ${(props) => (props.green ? '#093642' : props.white ? '#fff' : props.theme.grayDark)};
  font-family: ${(props) => (props.green ? 'MatterBold' : 'MatterRegular')};
  @media (max-width: ${breakpoints.l}px) {
    font-size: 16px;
  }
  @media (max-width: ${breakpoints.s}px) {
    font-size: 15px;
    width: auto;
  }
`
export const SyncsSection = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: ${breakpoints.l}px) {
    justify-content: center;
    align-items: center;
    margin-bottom: 24px;
  }
`
export const Flexbox = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: ${breakpoints.l}px) {
    gap: 16px;
    margin: 16px 0px 0px;
  }
`

export const TextContainer = styled.div`
  width: 90%;
  margin: auto;
  position: relative;
  z-index: 39 !important;
  .yotpo-reviews-star-ratings-widget {
    margin-bottom: 24px !important;
  }
  @media (max-width: ${breakpoints.l}px) {
    .yotpo-reviews-star-ratings-widget {
      padding-top: ${(props) => (props.singleSlide ? '4px' : '20px')} !important;
      justify-content: center !important;
    }
    .yotpo-reviews-star-ratings-widget {
      margin-bottom: 8px !important;
    }
  }
  @media (max-width: ${breakpoints.s}px) {
    padding-top: ${(props) => (props.singleSlide ? '4px' : '8px')} !important;
    .yotpo-reviews-star-ratings-widget {
      justify-content: center !important;
    }
  }
`
export const HideOnDesktop = styled(HiddenOnDesktop)`
  position: relative;
`
